import SVG_GREEN_SHIELD from '../../../images/invoice-green-shield.svg';
import SVG_WAR from '../../../images/invoice-payerno-warning.svg';
import SVG_ERROR from '../../../images/invoice-payerno-error.png';
import { toCDB } from '../../../lib/lib-util';
var checkedStatusMap = {
    SUCCESS: {
        nameTip: i18n.get('校验正确，和公司抬头结果一致'),
        numberTip: i18n.get('校验正确，和公司纳税人识别号一致'),
        icon: SVG_GREEN_SHIELD
    },
    NO_VISIBLE: {
        nameTip: i18n.get('校验失败，不属于可用的公司抬头'),
        numberTip: i18n.get('校验失败，不属于可用的纳税人识别号'),
        icon: SVG_WAR
    },
    NO_RESULT: {
        nameTip: '',
        numberTip: '',
        icon: SVG_ERROR
    }
};
var defaultCheckRes = { nameTip: '', numberTip: '', icon: '' };
export function getCurrentPayerInfo(item) {
    var entity = item.entity, formData = item.formData;
    return {
        name: formData[i18n.get("E_{__k0}_\u8D2D\u4E70\u65B9\u540D\u79F0", { __k0: entity })],
        payerNo: formData[i18n.get("E_{__k0}_\u8D2D\u4E70\u65B9\u7EB3\u7A0E\u4EBA\u8BC6\u522B\u53F7", { __k0: entity })],
        date: formData["E_" + entity + "_invdate"]
    };
}
export function getCurrentSellerInfo(item) {
    var entity = item.entity, formData = item.formData;
    return {
        name: formData[i18n.get("E_{__k0}_\u9500\u552E\u65B9\u540D\u79F0", { __k0: entity })],
        payerNo: formData[i18n.get("E_{__k0}_\u9500\u552E\u65B9\u7EB3\u7A0E\u4EBA\u8BC6\u522B\u53F7", { __k0: entity })],
        date: formData["E_" + entity + "_invdate"]
    };
}
export function checkInvoicePayerName(currentPayer, addInfo) {
    var name = currentPayer.name, payerNo = currentPayer.payerNo, date = currentPayer.date;
    var isPersonal = name === '个人';
    var payersPool = addInfo.payersPool, checkStatus = addInfo.checkStatus, checkMessage = addInfo.checkMessage;
    var nameMatchedPayer = findNameMatchedPayer(currentPayer, payersPool);
    var numberMatchedPayer = findNumberMatchedPayer(currentPayer, payersPool);
    var isBefore20170701 = date < 1498838400000;
    var hasPayerNo = !!payerNo;
    var isNumberPassed = !hasPayerNo
        ? false
        : nameMatchedPayer
            ? payerNo === nameMatchedPayer.payerNo
            : !!numberMatchedPayer;
    var checkedRes = checkedStatusMap[checkStatus] || defaultCheckRes;
    var title = name;
    var icon = isPersonal || !checkStatus ? '' : !isBefore20170701 && !hasPayerNo ? SVG_WAR : checkedRes.icon;
    var tooltip = isPersonal
        ? ''
        : !isBefore20170701 && !hasPayerNo
            ? i18n.get('开票信息不符')
            : checkedRes.nameTip || checkMessage;
    var className = isPersonal || nameMatchedPayer ? '' : 'red';
    var warningTitle = isPersonal || isBefore20170701 || !nameMatchedPayer || isNumberPassed ? '' : i18n.get('对应税号');
    var warningText = isPersonal || isBefore20170701 || !nameMatchedPayer || isNumberPassed ? '' : nameMatchedPayer.payerNo;
    return {
        title: title,
        icon: icon,
        tooltip: tooltip,
        className: className,
        warningTitle: warningTitle,
        warningText: warningText
    };
}
export function checkInvoicePayerNumber(currentPayer, addInfo) {
    var name = currentPayer.name, payerNo = currentPayer.payerNo, date = currentPayer.date;
    var isPersonal = name === '个人';
    var payersPool = addInfo.payersPool, checkStatus = addInfo.checkStatus, checkMessage = addInfo.checkMessage;
    var nameMatchedPayer = findNameMatchedPayer(currentPayer, payersPool);
    var numberMatchedPayer = findNumberMatchedPayer(currentPayer, payersPool);
    var isBefore20170701 = date < 1498838400000;
    var hasPayerNo = !!payerNo;
    var isNumberPassed = !hasPayerNo
        ? false
        : nameMatchedPayer
            ? payerNo === nameMatchedPayer.payerNo
            : !!numberMatchedPayer;
    var checkedRes = checkedStatusMap[checkStatus] || defaultCheckRes;
    var title = hasPayerNo ? payerNo : i18n.get('无法获取');
    var icon = isPersonal || isBefore20170701 || !checkStatus ? '' : !hasPayerNo ? SVG_WAR : checkedRes.icon;
    var tooltip = isPersonal || isBefore20170701
        ? ''
        : !hasPayerNo
            ? i18n.get('该发票上纳税人识别号信息缺失')
            : checkedRes.numberTip || checkMessage;
    var className = isPersonal || isBefore20170701 || isNumberPassed ? '' : 'red';
    var warningTitle = isPersonal || isBefore20170701 || !isNumberPassed || nameMatchedPayer ? '' : i18n.get('对应购买方');
    var warningText = isPersonal || isBefore20170701 || !isNumberPassed || nameMatchedPayer ? '' : numberMatchedPayer.name;
    return {
        title: title,
        icon: icon,
        tooltip: tooltip,
        className: className,
        warningTitle: warningTitle,
        warningText: warningText
    };
}
function findNameMatchedPayer(currentPayer, payersPool) {
    var currentPayerName = currentPayer.name;
    return payersPool.find(function (payer) {
        var invoicePayerName = currentPayerName
            .replace(/（/g, '(')
            .replace(/）/g, ')')
            .replace(/\s+/g, '');
        invoicePayerName = toCDB(invoicePayerName);
        var companyPayerName = payer.name
            .replace(/（/g, '(')
            .replace(/）/g, ')')
            .replace(/\s+/g, '');
        companyPayerName = toCDB(companyPayerName);
        return invoicePayerName === companyPayerName;
    });
}
function findNumberMatchedPayer(currentPayer, payersPool) {
    var currentPayerNumber = currentPayer.payerNo;
    return payersPool.find(function (payer) { return payer.payerNo === (currentPayerNumber && currentPayerNumber.toUpperCase()); });
}
export function getTaxAmount(detail) {
    if (detail === void 0) { detail = {}; }
    var entityId = detail.entityId, _a = detail.form, form = _a === void 0 ? {} : _a;
    var tags = form["E_" + entityId + "_\u4EF7\u7A0E\u5408\u8BA1"];
    return new Big(getMoney(tags)).toFixed(2);
}
export function getMoney(money) {
    return money ? (typeof money === 'object' ? (money.standard ? money.standard : '0.00') : money) : '0.00';
}
